module.exports = __webpack_public_path__ + "static/img/guidance13.e247bb37.png";